module.exports = __webpack_public_path__ + "static/media/mapkaORPEG.c4a4f2df.svg";